import React from 'react';

import { SubHeading }  from '../../components';
import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className='app__header app__wrapper section__padding' id='home'>
    <div className="app__wrapper_info">
      <SubHeading title="Chase the new flavour" />
      <h1 className="app__header-h1">The Key To Fine Dining</h1>
      <p className="p__opensans" style={{ margin: '2rem 0' }}>
        Taste the our special steaks, dishes, ribs, chops and Roadhouse favorites are grilled-to-order over an open flame. 
        Our steaks are butcher-selected and grilled over that signature mesquite wood flame.
      </p>
      <button type='button' className='custom__button' style={{background: '#DCCA87', fontSize: '1.2rem', borderRadius: '10px' }}>Explore Menu</button>
    </div>
    <div className="app__wrapper_img">
      <img src={images.welcome} alt="header img" />
    </div>
  </div>
);

export default Header;
